import _extends from "../../../../@babel/runtime/helpers/esm/extends.es.js";
import * as React from "react";
import { clsx } from "../../../../clsx/dist/clsx.es.js";
import { styled } from "@mui/system";
import { useGridRootProps } from "../../hooks/utils/useGridRootProps.es.js";
import { getDataGridUtilityClass } from "../../constants/gridClasses.es.js";
import { j as jsxRuntimeExports } from "../../../../react/jsx-runtime.es.js";
import composeClasses from "../../../utils/composeClasses/composeClasses.es.js";
const useUtilityClasses = (props, overflowedContent) => {
  const {
    classes
  } = props;
  const slots = {
    root: ["virtualScrollerContent", overflowedContent && "virtualScrollerContent--overflowed"]
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
const VirtualScrollerContentRoot = styled("div", {
  name: "MuiDataGrid",
  slot: "VirtualScrollerContent",
  overridesResolver: (props, styles) => styles.virtualScrollerContent
})({});
const GridVirtualScrollerContent = /* @__PURE__ */ React.forwardRef(function GridVirtualScrollerContent2(props, ref) {
  var _props$style;
  const rootProps = useGridRootProps();
  const overflowedContent = !rootProps.autoHeight && ((_props$style = props.style) == null ? void 0 : _props$style.minHeight) === "auto";
  const classes = useUtilityClasses(rootProps, overflowedContent);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(VirtualScrollerContentRoot, _extends({
    ref
  }, props, {
    ownerState: rootProps,
    className: clsx(classes.root, props.className)
  }));
});
export {
  GridVirtualScrollerContent
};
//# sourceMappingURL=GridVirtualScrollerContent.es.js.map
